import { amountFormatter, labelForPortfolioSummaryMacroCategoryType, percentageFormatter, walletErDetailPageMessages} from 'azshared';
import {Loader, LoaderSize} from '../../../../../components/loader/loader';
import InfographicPie from '../../../../../components/infographic-pie/infographic-pie';
import React from 'react';
import {useIntl} from 'react-intl';
import './portfolio-summary.scss';
import { PortfolioSummaryByMacroCategory } from 'azshared/build/main/lib/model/wallet/wallet-ow';

interface Props {
  loading: boolean;
  summary: PortfolioSummaryByMacroCategory;
}

export const PortfolioSummaryChart = (props: Props) => {
  const {formatMessage} = useIntl();
  const {loading, summary} = props;

  return <div className='portfolio-summary'>
    <h4>{formatMessage(walletErDetailPageMessages.portfolioSummaryTitle)}</h4>
    {!loading && <><p>
      <b>{percentageFormatter(summary?.macrocategory?.find(m => m.code === '011')?.percentage || 0, {isPercentage: true})}</b> {formatMessage(walletErDetailPageMessages.portfolioSummaryLabel)}
    </p></>}
    <div className={'portfolio-container' + (loading ? '-loader' : '')}>
      {loading && <Loader loadersize={LoaderSize.XL}/>}
      {!loading &&
        <>

          <InfographicPie
            items={summary?.macrocategory?.map(m => {
              return {value: m.percentage*100, label: formatMessage(labelForPortfolioSummaryMacroCategoryType(m.code,m.description))};
            })}
            biggerActiveItem
            forcedIndex={summary?.macrocategory?.findIndex(m => m.code === '011')}
            title={formatMessage(walletErDetailPageMessages.portfoglioSummaryTotal)}
            subtitle={amountFormatter(summary.totalAmount)}
            legend
            legendAlignment={'left'}
          />
        </>

      }
    </div>
  </div>;
};